import React from 'react';
import { ThemeProvider } from 'styled-components';
import { isVisualRefreshActive } from '@amzn/awsui-global-styles';
import { DEFAULT_THEME, lightVisualRefreshTheme, lightTheme, darkVisualRefreshTheme, darkTheme } from '../constants/theme.js';

const ThemeContextProvider = _ref => {
  let {
    children,
    theme = DEFAULT_THEME
  } = _ref;
  let selectedTheme;
  const isVR = isVisualRefreshActive();
  if (theme === DEFAULT_THEME) {
    selectedTheme = isVR ? lightVisualRefreshTheme : lightTheme;
  } else {
    selectedTheme = isVR ? darkVisualRefreshTheme : darkTheme;
  }
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: selectedTheme
  }, children);
};
var ThemeContextProvider$1 = ThemeContextProvider;

export { ThemeContextProvider$1 as default };
